export const TOOLTIP_SUPPRESSED_ATTR = "data-persona-tooltip-suppressed";
